import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "./firebase.js";
import { getDocs, collection } from "firebase/firestore";

import BgShape from "../images/chooseUs/d2.jpeg";

//import Bookjetski from "./Bookjetski.jsx";

import Bookdrone from "./Bookdrone.jsx";

function Pickdrone() {



  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  const [isModalOpens, setIsModalOpens] = useState(false);

  const openModals = () => setIsModalOpens(true);
  const closeModals = () => setIsModalOpens(false);


  const colStyle = {
    position: 'relative',
    height: '350px',
    marginBottom: '85px', // Space between stacked cards in mobile view
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%' // Make each card occupy full width
    ,  zIndex: 2,
  };
  
  return (
    <section id="pick-section" className="pick-section" style={{ marginTop: '-100px', marginBottom: '-60px' }}>
    <div className="container">
      <div className="pick-container__title" style={{ textAlign: 'center' }}>
        <h2>Book Drone Photoshoot</h2>
        <p>We provide excellent drone photshoot facility for our clients.</p>
      </div>
  
      <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
        {/* Card 1 */}
        <div className="col-12 col-md-6" style={{ padding: '10px', display: 'flex', justifyContent: 'center' }}>
          <div
            className="models-div__box"
            style={{
              backgroundColor: "black",
              borderRadius: "8px",
              transition: "transform 0.3s ease",
              boxShadow: "0px 0px 5px 7px #b8860b, 0px 3px 3px 4px #b8860b",
              overflow: "hidden",
              cursor: "pointer",
              width: '95%',
              maxWidth: '400px', // Ensures the card does not exceed a certain width
              position: 'relative',
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <div className="models-div__box__img" style={{ position: 'relative' }}>
              <img
                src={BgShape}
                alt="car_img"
                style={{
                  height: "250px",
                  width: "100%",
                  backgroundColor: 'white',
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              />
              <div
                className="models-div__box__img-overlay"
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
               Drone Photo Shoot
              </div>
            </div>
            <div className="models-div__box__descr" style={{ padding: "15px" }}>
              <div
                className="models-div__box__descr__price"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ margin: "5px 10px 5px 0", color: "white", fontSize: "24px" }}>
                  $200
                </h4>
                <p style={{ margin: "0", fontSize: "14px", color: "silver" }}>
                  for 1 hr
                </p>
              </div>
              <div className="models-div__box__descr__details">
                <span style={{ fontSize: "12px", margin: "2px", color: 'white' }}>
                ----Per Person-- <br></br>
                  &#x2022;100 Pictures Each <br></br>
                  &#x2022;2 Videos Each  <br></br>
                  &#x2022;20 Edited Pictures Each 
                </span>
              </div>
              <button
                className="models-div__box__descr__btn"
                style={{
                  height: "40px",
                  width: "100%",
                  background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #B8860B)',
                  backgroundSize: '200% 200%',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  marginTop: "10px",
                  transition: "background-color 0.3s ease",
                  fontSize: "15px",
                  color: 'white',
                }}
                onClick={openModal}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#20a4f3")}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#B8860B")}
              >
                Reserve Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <Bookdrone isModalOpen={isModalOpen} closeModal={closeModal} />
  </section>
  );



}

export default Pickdrone;
